import { Stack, Typography, BoxProps, TypographyProps } from "@mui/material";
import { InformationBox } from "@covertree/ui/content";
import { InfoButton } from "@covertree/ui/buttons";

interface InfoDisclaimerBoxProps extends BoxProps {
  children: React.ReactNode;
  typographyProps?: TypographyProps;
  dataTestId?: string;
  fontSize?: number;
  icon?: React.ReactNode;
  spacing?: number | { [key: string]: number };
}

export function InfoDisclaimerBox({
  children,
  dataTestId,
  fontSize = 16,
  typographyProps = {},
  icon = <InfoButton size="small" />,
  spacing = { xs: 2, sm: 1 },
  ...boxProps
}: InfoDisclaimerBoxProps) {
  return (
    <InformationBox data-testid={dataTestId} {...boxProps}>
      <Stack direction="row" spacing={spacing} alignItems="center">
        {icon}
        <Typography
          variant="body2"
          color="textPrimary"
          sx={{
            fontSize: {
              xs: 14,
              sm: fontSize,
            },
          }}
          {...typographyProps}>
          {children}
        </Typography>
      </Stack>
    </InformationBox>
  );
}
